import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import { request } from "@/js/http/http_request";
import { stockTypes, stockStatus, stockReservationTypes, listWineTypes, orderStatus, STOCK_PART } from "@/js/lists.ts";
import { regExpReferenceWarehouse } from "@/js/regexp_validation.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { hasRole, getLimitedLocations, isAddressNotLimited, getClientAppData } from "@/js/http/auth.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import returnComponent from "@/components/navigation/ReturnToList.vue";
import WarehouseSelectComponent from "@/components/warehouse/WarehouseSelectComponent.vue";
import StockCommittedDialog from "@/components/stock/StockCommittedDialog.vue";
import StockReservation from "@/components/stock/StockReservation.vue";
import StockPartFormModal from "@/components/stock/StockPartFormModal.vue";
import StockTransferDomesticNewPartFormModal from "@/components/stock/StockTransferDomesticNewPartFormModal.vue";
import StockSplitFormModal from "@/components/stock/StockSplitFormModal.vue";
import WineSupplierPriceModal from "@/components/supplier-prices/WineSupplierPriceModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import Error from "@/views/error/error.vue";
var defaultStock = {
  id_stock: null,
  stock_type: null,
  quantity: null,
  parts: [],
  quantity_committed: null,
  wine: {
    id_wine: null,
    producer: "",
    name: "",
    year: null,
    accountancy_code: null,
    displayName: ""
  },
  warehouse_default_departure: {
    id_warehouse: null
  },
  status: null,
  country_ids: [],
  id_warehouse: null,
  id_address_consignment_storage: null,
  reference_warehouse: "",
  reservation_type: stockReservationTypes.DEFAULT.id,
  reservation_user_id: null,
  address: {
    street: "",
    address_line_2: null,
    address_line_3: null,
    address_complement: null,
    zip: "",
    city: "",
    state: "",
    country: ""
  },
  creation_user_id: null,
  mvt_reasons: null,
  purchaseOrderId: null,
  firstAddPartPurchasePriceUnitEuroExVat: null
};
export default {
  name: "Stock",
  components: {
    confirm: confirmationComponent,
    return: returnComponent,
    WarehouseSelectComponent: WarehouseSelectComponent,
    StockCommittedDialog: StockCommittedDialog,
    StockReservation: StockReservation,
    StockPartFormModal: StockPartFormModal,
    StockTransferDomesticNewPartFormModal: StockTransferDomesticNewPartFormModal,
    StockSplitFormModal: StockSplitFormModal,
    WineSupplierPriceModal: WineSupplierPriceModal,
    ErrorModal: ErrorModal,
    Error: Error
  },
  props: ["idStock", "mode", "listCountries", "listStates", "wine", "loggedUserData"],
  data: function data(_this) {
    return {
      isForbiddenToAccessPage: false,
      canManage: false,
      canManageDomesticTransfers: false,
      canAccessSupplierPrices: false,
      limitedLocations: [],
      canManageWarehouseOfStock: true,
      clientAppData: null,
      form: {
        valid: false,
        subComponentsMountStatus: {
          stockReservation: false
        }
      },
      loading: {
        countriesLoaded: false,
        stockLoaded: false,
        warehouseLoaded: false
      },
      loaded: false,
      stock: _objectSpread({}, defaultStock),
      creationComment: "",
      compatibleOrderItems: [],
      gettingStock: {
        isPending: false
      },
      updatingSettings: {
        isPending: false
      },
      creatingStock: {
        isPending: false
      },
      closingStock: {
        isPending: false
      },
      editPartModal: {
        shown: false,
        partId: null
      },
      newStockTransferModal: {
        shown: false
      },
      splitStockModal: {
        shown: false
      },
      isWineSupplierPriceModalShown: false,
      wineSupplierPricesCount: null,
      fetchWineSupplierPricesToken: null,
      errorMessages: {
        reference: {
          unique: "An item already exists in this warehouse with this reference"
        }
      },
      managedExceptions: {
        error: {
          STOCK_DEPARTURE_WAREHOUSE_NOT_COMPATIBLE: "The warehouse departure is not compatible with the storage warehouse (continent)"
        },
        warning: {
          stock_already_exists: "This stock configuration already exists. Please edit the existing stock, or close the existing stock."
        }
      },
      countries: [],
      listWarehouses: [],
      wines: [],
      visible_country: false,
      visible_warehouse: false,
      consignmentAvailableStorageLocations: [{
        value: null,
        text: "Producer main address"
      }],
      stockCommittedShown: false,
      purchaseOrderId: null,
      fromOrderId: null,
      stockTypes: stockTypes,
      stockStatus: stockStatus,
      STOCK_PART: STOCK_PART,
      ERROR_DATA: ERROR_DATA,
      filterIntegerKey: filterIntegerKey,
      formRules: formRules,
      customRules: {
        mustBeReferenceWarehouse: function mustBeReferenceWarehouse(value) {
          return !!value && regExpReferenceWarehouse.test(value) || "Incorrect format. Only upper letters, numbers and '-' are allowed (example : DRB-01)";
        }
      }
    };
  },
  watch: {
    "stock.wine.id_wine": function stockWineId_wine(newVal) {
      var _this2 = this;
      if (newVal) {
        this.$nextTick().then(function () {
          _this2.$refs.wineSupplierPriceModal.initComponent();
        });
      }
    }
  },
  computed: {
    isStockValid: function isStockValid() {
      var _this$$refs$reservati;
      return this.form.valid && Object.values(this.form.subComponentsMountStatus).every(function (x) {
        return !!x;
      }) && ((_this$$refs$reservati = this.$refs.reservation) === null || _this$$refs$reservati === void 0 ? void 0 : _this$$refs$reservati.valid) && this.wineSupplierPricesCount > 0;
    },
    isAdding: function isAdding() {
      var _this$stock;
      return !((_this$stock = this.stock) !== null && _this$stock !== void 0 && _this$stock.id_stock);
    },
    allCountriesSelected: function allCountriesSelected() {
      return this.stock.country_ids.length === this.countries.length;
    },
    someCountriesSelected: function someCountriesSelected() {
      return this.stock.country_ids.length > 0 && !this.allCountriesSelected;
    },
    getIconForIntendedCountriesCloser: function getIconForIntendedCountriesCloser() {
      if (this.allCountriesSelected) return "mdi-close-box";
      if (this.someCountriesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    selectedWarehouse: function selectedWarehouse() {
      var _this3 = this;
      return this.listWarehouses.find(function (x) {
        return x.id_warehouse == _this3.stock.id_warehouse;
      });
    },
    isIntendedCountriesDifferentAsWarehouseDefault: function isIntendedCountriesDifferentAsWarehouseDefault() {
      if (this.visible_warehouse && this.visible_country && this.selectedWarehouse != null) {
        var warehouseDefaults = _toConsumableArray(this.selectedWarehouse.defaultIntendedCountries.map(function (x) {
          return x.id;
        }).sort());
        var countryIds = _toConsumableArray(this.stock.country_ids.sort());
        if (JSON.stringify(warehouseDefaults) != JSON.stringify(countryIds)) {
          return true;
        }
      }
      return false;
    },
    listWarehousesForDefaultDeparture: function listWarehousesForDefaultDeparture() {
      if (this.stock.id_stock) {
        return this.listWarehouses;
      }
      var warehouses = _toConsumableArray(this.listWarehouses);
      warehouses.unshift({
        id_warehouse: null,
        name: "#According to defaults departures configuration"
      });
      return warehouses;
    },
    rulesForWarehouseSelectComponent: function rulesForWarehouseSelectComponent() {
      return [this.formRules.mustSelectValue];
    },
    isClosedStock: function isClosedStock() {
      return this.stock.status == stockStatus.filter(function (ss) {
        return ss.id === "CLOSED";
      })[0].value;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.gettingStock.isPending || this.updatingSettings.isPending || this.creatingStock.isPending || this.closingStock.isPending;
    },
    isSplitAvailable: function isSplitAvailable() {
      var _this$stock2;
      return !this.isAdding && ((_this$stock2 = this.stock) === null || _this$stock2 === void 0 ? void 0 : _this$stock2.quantity) > 0 && this.canManageWarehouseOfStock;
    },
    isNewTransferAvailable: function isNewTransferAvailable() {
      var _this$stock3, _this$stock4;
      return this.canManageDomesticTransfers && !this.isAdding && ((_this$stock3 = this.stock) === null || _this$stock3 === void 0 ? void 0 : _this$stock3.stock_type.toLowerCase()) === "stock" && ((_this$stock4 = this.stock) === null || _this$stock4 === void 0 ? void 0 : _this$stock4.quantity) > 0 && this.canManageWarehouseOfStock;
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this4$$route$query, _this4$$route$query2, _this4$$route$query4, _this4$$route$query5, _this4$listCountries, _this4$stock$wine;
      var _this4$$route$query3, _this4$limitedLocatio, _this4$stock, _this4$stock$warehous, _this4$stock$warehous2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this4.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK);
            _this4.canAccessSupplierPrices = _this4.canManage && hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
            _this4.canManageDomesticTransfers = hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK_DOMESTIC_TRANSFERS);
            _this4.clientAppData = getClientAppData(_this4);
            _this4.limitedLocations = getLimitedLocations(_this4.loggedUserData);
            _this4.stock.id_stock = ((_this4$$route$query = _this4.$route.query) === null || _this4$$route$query === void 0 ? void 0 : _this4$$route$query.id_stock) || _this4.idStock;
            if ((_this4$$route$query2 = _this4.$route.query) !== null && _this4$$route$query2 !== void 0 && _this4$$route$query2.id_po) {
              _this4.purchaseOrderId = _this4.$route.query.id_po;
            }
            if (typeof _this4.wine != "undefined") {
              _this4.stock.wine = _this4.wine;
            } else {
              _this4.stock.wine.id_wine = (_this4$$route$query3 = _this4.$route.query) === null || _this4$$route$query3 === void 0 ? void 0 : _this4$$route$query3.id_wine;
            }
            if (((_this4$$route$query4 = _this4.$route.query) === null || _this4$$route$query4 === void 0 ? void 0 : _this4$$route$query4.warehouseId) > 0) {
              _this4.stock.stock_type = "stock";
              _this4.changeTypeStock("stock");
              _this4.stock.id_warehouse = _this4.$route.query.warehouseId;
            }
            if (((_this4$$route$query5 = _this4.$route.query) === null || _this4$$route$query5 === void 0 ? void 0 : _this4$$route$query5.quantity) > 0) {
              _this4.stock.quantity = _this4.$route.query.quantity;
            }
            _context.next = 12;
            return _this4.getWarehouses();
          case 12:
            if (!(((_this4$listCountries = _this4.listCountries) === null || _this4$listCountries === void 0 ? void 0 : _this4$listCountries.length) > 0)) {
              _context.next = 16;
              break;
            }
            _this4.countries = _toConsumableArray(_this4.listCountries);
            _context.next = 18;
            break;
          case 16:
            _context.next = 18;
            return _this4.getImplantedCountries();
          case 18:
            if (!_this4.stock.id_stock) {
              _context.next = 24;
              break;
            }
            _context.next = 21;
            return _this4.getStock();
          case 21:
            if (((_this4$limitedLocatio = _this4.limitedLocations) === null || _this4$limitedLocatio === void 0 ? void 0 : _this4$limitedLocatio.length) > 0) {
              if (((_this4$stock = _this4.stock) === null || _this4$stock === void 0 ? void 0 : _this4$stock.stock_type.toLowerCase()) === "stock") {
                if (!_this4.listWarehouses.map(function (x) {
                  return x.id_warehouse;
                }).includes(_this4.stock.id_warehouse)) {
                  _this4.isForbiddenToAccessPage = true;
                }
              }
              _this4.canManageWarehouseOfStock = isAddressNotLimited(_this4.loggedUserData, (_this4$stock$warehous = _this4.stock.warehouse) === null || _this4$stock$warehous === void 0 || (_this4$stock$warehous = _this4$stock$warehous.address) === null || _this4$stock$warehous === void 0 || (_this4$stock$warehous = _this4$stock$warehous.country) === null || _this4$stock$warehous === void 0 ? void 0 : _this4$stock$warehous.id_country, (_this4$stock$warehous2 = _this4.stock.warehouse) === null || _this4$stock$warehous2 === void 0 || (_this4$stock$warehous2 = _this4$stock$warehous2.address) === null || _this4$stock$warehous2 === void 0 || (_this4$stock$warehous2 = _this4$stock$warehous2.state) === null || _this4$stock$warehous2 === void 0 ? void 0 : _this4$stock$warehous2.id_state);
            }
            _context.next = 25;
            break;
          case 24:
            _this4.getCompatibleOrderItems();
          case 25:
            _context.next = 27;
            return _this4.getAvailableWines();
          case 27:
            if (((_this4$stock$wine = _this4.stock.wine) === null || _this4$stock$wine === void 0 ? void 0 : _this4$stock$wine.id_wine) > 0) {
              _this4.stock.wine = _this4.wines.find(function (x) {
                return x.id_wine == _this4.stock.wine.id_wine;
              });
            }
            _this4.chooseWine();
            _this4.loading.stockLoaded = true;
            _this4.loaded = true;
            _this4.handleLoading(_this4.loading.countriesLoaded, _this4.loading.stockLoaded, _this4.loading.warehouseLoaded);
          case 32:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    changeTypeStock: function changeTypeStock(stockType) {
      if (stockType == "stock") {
        this.visible_country = true;
        this.visible_warehouse = true;
        this.stock.id_warehouse = 0;
        this.stock.id_address_consignment_storage = null;
      } else if (stockType == "consignment") {
        this.visible_country = true;
        this.visible_warehouse = false;
        this.stock.id_warehouse = 0;
        this.fromOrderId = null;
        this.firstAddPartPurchasePriceUnitEuroExVat = null;
      }
      this.setConsignmentAvailableStorageLocations();
    },
    chooseWine: function chooseWine() {
      var _this$stock$wine;
      this.stock.reference_warehouse = ((_this$stock$wine = this.stock.wine) === null || _this$stock$wine === void 0 ? void 0 : _this$stock$wine.accountancy_code) || null;
      if (!!this.stock.id_address_consignment_storage && this.stock.wine) {
        var _this$stock$wine2;
        if (!((_this$stock$wine2 = this.stock.wine) !== null && _this$stock$wine2 !== void 0 && (_this$stock$wine2 = _this$stock$wine2.producer.alternativeStorageAddresses) !== null && _this$stock$wine2 !== void 0 && _this$stock$wine2.map(function (x) {
          return x.address.id_address;
        }).includes(this.stock.id_address_consignment_storage))) {
          this.stock.id_address_consignment_storage = null;
        }
      }
      this.setConsignmentAvailableStorageLocations();
      this.getCompatibleOrderItems();
    },
    changeWarehouse: function changeWarehouse(idWarehouse) {
      this.stock.id_warehouse = idWarehouse;
      var warehouseChosen = this.listWarehouses.find(function (x) {
        return x.id_warehouse == idWarehouse;
      });
      if (warehouseChosen) {
        var _this$stock$country_i;
        if (((_this$stock$country_i = this.stock.country_ids) === null || _this$stock$country_i === void 0 ? void 0 : _this$stock$country_i.length) === 0) {
          this.defineIntededCountriesAsDefault();
        }
        if (warehouseChosen.default_stock_reservation_type != stockReservationTypes.DEFAULT.id) {
          this.stock.reservation_type = warehouseChosen.default_stock_reservation_type;
          if (warehouseChosen.default_stock_reservation_type == stockReservationTypes.SPECIFIC_CUSTOMER.id) {
            this.stock.reservation_user_id = warehouseChosen.default_stock_reservation_user_id;
            this.stock.reservation_consultant_id = null;
          } else if (warehouseChosen.default_stock_reservation_type == stockReservationTypes.SPECIFIC_CONSULTANT.id) {
            this.stock.reservation_consultant_id = warehouseChosen.default_stock_reservation_consultant_id;
            this.stock.reservation_user_id = null;
          } else {
            this.stock.reservation_user_id = null;
            this.stock.reservation_consultant_id = null;
          }
        }
      }
    },
    defineIntededCountriesAsDefault: function defineIntededCountriesAsDefault() {
      this.stock.country_ids = this.selectedWarehouse.defaultIntendedCountries.map(function (x) {
        return x.id;
      });
    },
    fetchWarhousesWhenItemsUpdated: function fetchWarhousesWhenItemsUpdated(idWarehouse) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.getWarehouses();
            case 2:
              _this5.changeWarehouse(idWarehouse);
              _this5.$refs.warehouseSelect.updateModel(idWarehouse);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changeIntendedCountries: function changeIntendedCountries() {
      var _this6 = this;
      this.$nextTick(function () {
        if (_this6.allCountriesSelected) {
          _this6.stock.country_ids = [];
        } else {
          _this6.stock.country_ids = _this6.countries.map(function (x) {
            return x.id_country;
          });
        }
      });
    },
    getStock: function getStock() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this8, url, response, stockType;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this7.gettingStock.isPending = true;
              _this7.loading.stockLoaded = false;
              _this7.handleLoading(_this7.loading.countriesLoaded, _this7.loading.stockLoaded, _this7.loading.warehouseLoaded);
              if (!_this7.stock.id_stock) {
                _context3.next = 17;
                break;
              }
              _this8 = _this7;
              url = "/v1/stock/";
              url += _this8.stock.id_stock;
              _context3.next = 9;
              return request(url, "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this8.managedExceptions);
                handleErrorData(_this8, errorData);
                _this8.gettingStock.isPending = false;
                _this8.loading.stockLoaded = true;
                _this8.handleLoading(_this8.loading.countriesLoaded, _this8.loading.stockLoaded, _this8.loading.warehouseLoaded);
              });
            case 9:
              response = _context3.sent;
              _this7.gettingStock.isPending = false;
              _this7.loaded = true;
              if (_this7.stock.id_stock) {
                _this7.stock = _objectSpread(_objectSpread(_objectSpread({}, _this7.stock), response.data), {}, {
                  stock_type: response.data.stock_type.toLowerCase()
                });
              }
              stockType = _this7.stock.stock_type.toLowerCase();
              if (stockType == "consignment") {
                _this7.visible_country = true;
                _this7.visible_warehouse = false;
              } else if (stockType == "stock") {
                _this7.visible_country = true;
                _this7.visible_warehouse = true;
              }
              _this7.loading.stockLoaded = true;
              _this7.handleLoading(_this7.loading.countriesLoaded, _this7.loading.stockLoaded, _this7.loading.warehouseLoaded);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    createNewStock: function createNewStock() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this9$stock$warehous;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this9.$EventBus.$emit("loading", true);
              _this9.creatingStock.isPending = true;
              data = {
                stockType: _this9.stock.stock_type,
                wineId: _this9.stock.wine.id_wine,
                quantity: _this9.stock.quantity,
                creationComment: _this9.creationComment,
                purchaseUnitPriceEuroExVat: _this9.stock.firstAddPartPurchasePriceUnitEuroExVat,
                countryIds: _this9.stock.country_ids,
                warehouseId: _this9.stock.id_warehouse,
                referenceWarehouse: _this9.stock.reference_warehouse,
                consignmentStorageAddressId: _this9.stock.id_address_consignment_storage,
                reservationType: _this9.stock.reservation_type,
                reservationUserId: _this9.stock.reservation_user_id,
                reservationConsultantId: _this9.stock.reservation_consultant_id,
                hasLowStockAlert: _this9.stock.hasLowStockAlert,
                lowStockAlertQuantity: _this9.stock.lowStockAlertQuantity,
                warehouseDefaultDepartureId: (_this9$stock$warehous = _this9.stock.warehouse_default_departure) === null || _this9$stock$warehous === void 0 ? void 0 : _this9$stock$warehous.id_warehouse,
                purchaseOrderId: _this9.purchaseOrderId,
                orderId: _this9.fromOrderId
              };
              _this = _this9;
              _context4.next = 6;
              return request("/v1/stock/", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create the new stock", true);
                handleErrorData(_this, errorData);
                _this.creatingStock.isPending = false;
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 6:
              if (_this9.mode != "popin") {
                _this9.$router.push({
                  name: "adminStockList"
                });
              } else {
                _this9.$emit("agree");
              }
              _this9.resetStock();
              _this9.$toasted.show("Stock created", {
                type: "success"
              });
              _this9.creatingStock.isPending = false;
              _this9.$EventBus.$emit("loading", false);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    updateStockSettings: function updateStockSettings() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this10$stock$warehou;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this10.$EventBus.$emit("loading", true);
              _this10.updatingSettings.isPending = true;
              data = {
                countryIds: _this10.stock.country_ids,
                warehouseId: _this10.stock.id_warehouse,
                referenceWarehouse: _this10.stock.reference_warehouse,
                consignmentStorageAddressId: _this10.stock.id_address_consignment_storage,
                reservationType: _this10.stock.reservation_type,
                reservationUserId: _this10.stock.reservation_user_id,
                reservationConsultantId: _this10.stock.reservation_consultant_id,
                hasLowStockAlert: _this10.stock.hasLowStockAlert,
                lowStockAlertQuantity: _this10.stock.lowStockAlertQuantity,
                warehouseDefaultDepartureId: (_this10$stock$warehou = _this10.stock.warehouse_default_departure) === null || _this10$stock$warehou === void 0 ? void 0 : _this10$stock$warehou.id_warehouse
              };
              _this = _this10;
              _context5.next = 6;
              return request("/v1/stocks/" + _this10.stock.id_stock, "put", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the stock settings", true);
                handleErrorData(_this, errorData);
                _this.updatingSettings.isPending = false;
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 6:
              _this10.$toasted.show("Stock settings updated", {
                type: "success"
              });
              _this10.updatingSettings.isPending = false;
              _this10.$EventBus.$emit("loading", false);
              _this10.getStock();
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    cancel: function cancel() {
      if (this.mode != "popin") {
        this.$router.push({
          name: "adminStockList"
        });
      } else {
        this.$emit("cancel");
      }
      this.resetStock();
    },
    showConfirmDelete: function showConfirmDelete() {
      var _this11 = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to close this stock ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          _this11.closingStock.isPending = true;
          var _this12 = _this11;
          request("/v1/stock/" + _this12.stock.id_stock, "delete", null, true, "api").then(function (_) {
            _this12.$toasted.show("Stock closed.", {
              type: "success"
            });
            _this12.closingStock.isPending = false;
            window.history.back();
          }).catch(function (e) {
            var errorData = getErrorData(e, _this12.managedExceptions, "Unable to close the stock", true);
            handleErrorData(_this12, errorData);
            _this12.closingStock.isPending = false;
          });
        }
      });
    },
    getWarehouses: function getWarehouses() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this13;
              _context6.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                _this.loading.warehouseLoaded = true;
                _this.handleLoading(_this.loading.countriesLoaded, _this.loading.stockLoaded, _this.loading.warehouseLoaded);
                throw e;
              });
            case 3:
              response = _context6.sent;
              _this13.listWarehouses = _toConsumableArray(response.data.warehouses);
              _this13.loading.warehouseLoaded = true;
              _this13.handleLoading(_this13.loading.countriesLoaded, _this13.loading.stockLoaded, _this13.loading.warehouseLoaded);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getImplantedCountries: function getImplantedCountries() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var clientAppData, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              clientAppData = {
                client_id: _this14.$whitelabel.clientId,
                client_secret: _this14.$whitelabel.clientSecret
              };
              _context7.next = 3;
              return request("/v1/countries?implantedMarket=true", "post", clientAppData, false, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load countries");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context7.sent;
              _this14.countries = _toConsumableArray(response.data.countries);
              _this14.loading.countriesLoaded = true;
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getAvailableWines: function getAvailableWines() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return request("/v1/stock?wines=true", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load available wines");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 2:
              response = _context8.sent;
              _this15.wines = _toConsumableArray(response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              }));
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getCompatibleOrderItems: function getCompatibleOrderItems() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this17;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this16.compatibleOrderItems = [];
              _this16.fromOrderId = null;
              if (!_this16.stock.wine.id_wine) {
                _context9.next = 6;
                break;
              }
              _this17 = _this16;
              _context9.next = 6;
              return request("/v1/orders/compatible-items?wineId=".concat(_this16.stock.wine.id_wine), "get", null, true, "api").then(function (response) {
                _this17.compatibleOrderItems = response.data.value.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    text: "".concat(x.quantity, " b. on ").concat(x.reference.shorterReference(), " ").concat(x.invoiceNumberLabel ? "(" + x.invoiceNumberLabel + ")" : "", " ").concat(x.isDestinationInbound ? "(inbound) " : "", ", ").concat(orderStatus.find(function (os) {
                      return os.status === x.status;
                    }).shortValue, ": ").concat(new Date(x.deliveryDate).toLocaleDateString("en-US"))
                  });
                });
                _this17.compatibleOrderItems.sort(function (a, b) {
                  return a.isDestinationInbound ? -1 : 1;
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this17.managedExceptions, "Unable to get orders.");
                handleErrorData(_this17, errorData);
              });
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    resetStock: function resetStock() {
      this.stock = _objectSpread({}, defaultStock);
    },
    updateStockReservation: function updateStockReservation(form) {
      this.stock.reservation_type = form.stockReservationType;
      this.stock.reservation_user_id = form.stockReservationUserId;
      this.stock.reservation_consultant_id = form.stockReservationConsultantId;
    },
    firstMountStockReservation: function firstMountStockReservation() {
      this.form.subComponentsMountStatus.stockReservation = true;
    },
    setConsignmentAvailableStorageLocations: function setConsignmentAvailableStorageLocations() {
      var _this$stock$wine3;
      var array = [{
        value: null,
        text: "Producer main address"
      }];
      if (((_this$stock$wine3 = this.stock.wine) === null || _this$stock$wine3 === void 0 || (_this$stock$wine3 = _this$stock$wine3.producer.alternativeStorageAddresses) === null || _this$stock$wine3 === void 0 ? void 0 : _this$stock$wine3.length) > 0) {
        array = [].concat(_toConsumableArray(array), _toConsumableArray(this.stock.wine.producer.alternativeStorageAddresses.map(function (x) {
          return {
            value: x.address.id_address,
            text: x.name + " (" + x.address.country.printable_name + ")"
          };
        })));
      }
      this.consignmentAvailableStorageLocations = array;
    },
    startEditPartQuantity: function startEditPartQuantity(part) {
      var _this18 = this;
      this.editPartModal.partId = part.id;
      this.editPartModal.shown = true;
      this.$nextTick(function () {
        _this18.$refs.stockPartForm.open();
      });
    },
    openNewStockPart: function openNewStockPart() {
      var _this19 = this;
      this.editPartModal.partId = null;
      this.editPartModal.shown = true;
      this.$nextTick(function () {
        _this19.$refs.stockPartForm.open();
      });
    },
    closePartModal: function closePartModal() {
      this.editPartModal.shown = false;
      this.editPartModal.partId = null;
    },
    openNewStockTransfer: function openNewStockTransfer() {
      var _this20 = this;
      this.newStockTransferModal.shown = true;
      this.$nextTick(function () {
        _this20.$refs.newStockTransferForm.open();
      });
    },
    closeNewStockTransfer: function closeNewStockTransfer() {
      this.newStockTransferModal.shown = false;
    },
    openSplitStock: function openSplitStock() {
      var _this21 = this;
      this.splitStockModal.shown = true;
      this.$nextTick(function () {
        _this21.$refs.splitStockForm.open();
      });
    },
    closeSplitStock: function closeSplitStock() {
      this.splitStockModal.shown = false;
    },
    handleLoading: function handleLoading(countriesLoaded, stockLoaded, warehouseLoaded) {
      this.$EventBus.$emit("loading", !(countriesLoaded && stockLoaded && warehouseLoaded));
    },
    showCommittedDetails: function showCommittedDetails() {
      this.stockCommittedShown = true;
    },
    closeCommittedDetails: function closeCommittedDetails() {
      this.stockCommittedShown = false;
    },
    goToPurchaseOrder: function goToPurchaseOrder(poId) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: poId
        }
      };
    },
    goToOrder: function goToOrder(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    goToProduct: function goToProduct(wine) {
      var routeParams = {};
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine,
          readOnly: true,
          routeParams: routeParams
        }
      };
    },
    openSupplierPrices: function openSupplierPrices() {
      var _this22 = this;
      this.isWineSupplierPriceModalShown = true;
      this.$nextTick(function () {
        _this22.$refs.wineSupplierPriceModal.open();
      });
    },
    closeSupplierPrices: function closeSupplierPrices() {
      this.isWineSupplierPriceModalShown = false;
    },
    filterVAutocomplete: filterVAutocomplete,
    getLimitedLocations: getLimitedLocations
  }
};